/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, Fragment, useRef } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import MainHeader from "../../../../Shared/components/Header";
import PurchaseIcon from "../../../../../assets/images/icon_menus/PurchaseIcon.json";
import clsx from 'clsx';
import { Box } from "@mui/material";
import { Space, Button } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useParams, Link } from "react-router-dom";
import { checkCRUDViewPermission, checkComponentPermission, currencyFormat, capitalizeFirstLetter } from "../../../../../helpers/utilities";
import { CustomAccordion } from "../../../../Shared/components/AccordionComponent";
import crudActions from "../../../../CRUD/redux/actions";
import usePrevious from "../../../../Shared/components/Previous";
import { DeliveryLinesList, DeliveryChallan, DeliveryView } from "./Block";
import { AESEncrypt } from "../../../../../helpers/Crypto";


export default function GoodsReceiptNoteView(props) {
    const { readDetails, getData, getList } = useSelector(state => state.crudReducer);
    const { roleManagement } = useSelector(state => state.authReducer);
    const [showDetails, setShowDetails] = useState(true);
    const [visible, setVisible] = useState(false);
    const dispatch = useDispatch();
    const { history } = props;
    let { goodsID } = useParams();
    const prevReadDetails = usePrevious(readDetails);
    const [loadMore, setLoadMore] = useState(false);
    const [details, setDetails] = useState({});
    const childRef = useRef('');
    const [value, setValue] = useState('lineView');

    useEffect(() => {
        console.log(goodsID);
        if (goodsID === undefined) {
            history.push("/purchase/transactions/goods-receipt-note");
            return true;
        }
        if (roleManagement !== '' && checkCRUDViewPermission('Goods Receipt Note', 'view', history, 'Purchase')) {
            dispatch({ type: crudActions.READ_DETAILS_START, id: goodsID, url: "v1/sales-order/purchase-goods" });
        }
    }, [roleManagement]);

    useEffect(() => {
        if (prevReadDetails !== undefined && readDetails && prevReadDetails !== readDetails) {
            setShowDetails(false);
            // dispatch({
            //     type: crudActions.GET_DETAILS_START,
            //     url: 'v1/sales-delivery/sales-delivery-line-items',
            //     skip: 0,
            //     filter: {
            //         where: { salesDeliveryId: deliveryID },
            //         order: 'createTs desc'
            //     }
            // })
        }
    }, [readDetails]);

    const prevGetData = usePrevious(getData);
    useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData.length > 0) {
                    setLoadMore(true);
                } else {
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);


    const handleShareDocument = (details) => {
        details.purchaseOrderLineItems = getList ? getList.sort((a, b) => a.lineNumber - b.lineNumber) : [];
        setDetails(details);
        setVisible(true);
    }

    const handleChange = (newValue) => {
        setValue(newValue);
        childRef?.current?.handleAdjustHeight();
    };

    const classes = customStyles();
    return (
        <Fragment>
            <MainHeader {...props} cls={'newImg'} img={PurchaseIcon} title={'Purchase'} links={[{ 'label': 'Purchase', 'link': '/purchase' }, { 'label': 'Goods Receipt Note', 'link': '' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin, classes.listTableSticky, { [classes.scrollBorder]: !showDetails })}>
                <div id="containerDiv" className={clsx(classes.stickyContainer)}>
                    <CustomAccordion
                        title={'Goods Receipt'}
                        top={"0"}
                        topVisible={"50px"}
                        zIndex={9}
                        showDetails={showDetails}
                        index={0}
                        ref={childRef}
                        component={
                            <Box
                                className={clsx(classes.removeUnderline, classes.positionRelative)}
                                component="div">
                                {
                                    showDetails ? <div style={{ textAlign: "center" }}>
                                        <div className={classes.loadMoreCircle}></div>
                                    </div> :
                                        <>
                                            <div className={clsx(classes.tabWrapSubmit)}>
                                                <Space direction="horizontal" align="center" size={[10, 10]}>
                                                    {
                                                        roleManagement !== '' && checkComponentPermission('Goods Receipt Note', 'Page', 'View Document') &&
                                                        <Button
                                                            key="share"
                                                            color="primary"
                                                            variant="contained"
                                                            className={clsx(classes.AddMoreBtn, classes.marginRight0)}
                                                            onClick={() => handleShareDocument(readDetails)}
                                                        >View Document</Button>
                                                    }
                                                    {
                                                        roleManagement !== '' && checkComponentPermission('Goods Receipt Note', 'Page', 'Create Invoice') && readDetails?.deliveryStatus === 'DELIVERED' &&
                                                        <Link
                                                            to={`/purchase/transactions/goods-receipt-note/${AESEncrypt(
                                                                {
                                                                    deliveryId: readDetails.id,
                                                                    single: true
                                                                })}/invoice`}
                                                            className={clsx(classes.modalBtn, classes.marginRight0)}>Create Invoice</Link>
                                                    }
                                                </Space>
                                            </div>
                                            <DeliveryView
                                                classes={classes}
                                                clsx={clsx}
                                                form={readDetails}
                                                handleChange={(v) => handleChange(v)}
                                                value={value}
                                                currencyFormat={(amount) => currencyFormat(amount)}
                                                capitalizeFirstLetter={(v) => capitalizeFirstLetter(v)}
                                            />
                                        </>
                                }
                            </Box>
                        }
                    />
                    <CustomAccordion
                        title={'Goods Receipt Note Lines'}
                        top={"49"}
                        topVisible={"150px"}
                        zIndex={7}
                        showDetails={showDetails}
                        index={1}
                        ref={childRef}
                        component={
                            <>
                                {
                                    showDetails ? <div className={classes.textAlignCenter}>
                                        <div className={classes.loadMoreCircle}></div>
                                    </div > : <>
                                        <DeliveryLinesList
                                            classes={classes}
                                            loadMore={!showDetails}
                                            clsx={clsx}
                                            lines={readDetails?.purchaseGoodsLineItems ? readDetails?.purchaseGoodsLineItems?.sort((a, b) => a.lineNumber - b.lineNumber) : []}
                                            roleManagement={roleManagement}
                                            checkComponentPermission={(v, page, d) => checkComponentPermission(v, page, d)}
                                        />
                                    </>
                                }
                            </>
                        }
                    />
                    <DeliveryChallan
                        visible={visible}
                        details={details}
                        classes={classes}
                        clsx={clsx}
                        handleClose={() => setVisible(false)}
                        {...props}
                    />
                </div>
            </div>
        </Fragment>
    )
}